module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_3016.de3b7903.png";